<div class="photo-view-dialog-container">
  <div class="photo-view-dialog-header">
    <div class="photo-view-title-wrap">
      <mat-icon class="header-icon">account_circle</mat-icon>
      <span class="photo-view-title">{{ data.userName || ('USERMENU.PHOTO_MENU.VIEW_PHOTO' | translate) }}</span>
    </div>
    <button
      mat-icon-button
      (click)="close()"
      class="close-btn"
      [attr.aria-label]="'USERMENU.PHOTO_MENU.CLOSE' | translate"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="photo-view-dialog-body">
    <img [src]="data.photoUrl" [alt]="data.userName || 'Foto de Perfil'" class="full-photo-img" />
  </div>
</div>
